import { partnerControllerGetAllPartner } from '@/services/api-v3/partner';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.PartnerPayloadDto[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async () => {
    const res = await partnerControllerGetAllPartner({
      pageSize: -1,
      filter: JSON.stringify({ isActive: true }),
    });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.PartnerPayloadDto) => ({
          ...pre,
          [curr.id]: curr.name,
        }),
        {},
      ),
    );
    setValueOptions(
      res.data?.map((item: API.PartnerPayloadDto) => ({ value: item.id, label: item.name })),
    );
  };
  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
